import PublicAccessClient from "./clients/PurchaseOrderClient";

export default {
  getSearch(body, log = "true") {
    return PublicAccessClient.get(`search?filter=${body}&log=${log}`);
  },
  getSearchWithBranch(body, log = "true") {
    return PublicAccessClient.get(
      `search?filter=${body.filter}&branch=${body.branch}&log=${log}`
    );
  },
};
